import React, { useState } from 'react';
import { Container, Button } from 'react-bootstrap';
import SettingsTable from '../../../../components/tables/SettingsTable';
import BankMasterModal from '../../../../components/modals/BankMasterModal';

const BankMaster = () => {
  // Sample data generator
  const generateSampleData = (count = 50) => {
    const banks = [
      'HDFC Bank', 'ICICI Bank', 'State Bank of India', 'Axis Bank',
      'Kotak Mahindra Bank', 'Punjab National Bank', 'Bank of Baroda',
      'Canara Bank', 'Union Bank', 'IDBI Bank', 'Yes Bank', 'IndusInd Bank',
      'Federal Bank', 'RBL Bank', 'IDFC First Bank', 'Bandhan Bank'
    ];
    const keywords = ['HDFC', 'ICICI', 'SBI', 'AXIS', 'KOTAK', 'PNB', 'BOB', 'CANARA', 'UNION', 'IDBI', 'YES', 'INDUS', 'FEDERAL', 'RBL', 'IDFC', 'BANDHAN'];
    const verifyStatuses = ['Verified', 'Pending', 'Not Verified'];
    const modes = ['NEFT', 'RTGS', 'IMPS', 'UPI'];
    const creditCards = ['Yes', 'No'];
    
    return Array.from({ length: count }, (_, i) => ({
      bankName: banks[i % banks.length],
      keyword: keywords[i % keywords.length],
      ifsc: `${keywords[i % keywords.length]}0${String(Math.floor(Math.random() * 1000000)).padStart(6, '0')}`,
      maxlength: Math.floor(Math.random() * 5) + 16,
      minlength: Math.floor(Math.random() * 3) + 9,
      verifyStatus: verifyStatuses[Math.floor(Math.random() * verifyStatuses.length)],
      mode: modes[Math.floor(Math.random() * modes.length)],
      creditCard: creditCards[Math.floor(Math.random() * creditCards.length)]
    }));
  };

  const [data, setData] = useState(generateSampleData(50));
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState('add');
  const [selectedBank, setSelectedBank] = useState(null);

  const handleAddBank = () => {
    setModalMode('add');
    setSelectedBank(null);
    setShowModal(true);
  };

  const handleEditBank = (bank) => {
    setModalMode('edit');
    setSelectedBank(bank);
    setShowModal(true);
  };

  const handleSaveBank = (bankData) => {
    if (modalMode === 'add') {
      setData([...data, bankData]);
    } else {
      setData(data.map(item => 
        item.bankName === selectedBank.bankName && item.ifsc === selectedBank.ifsc
          ? { ...item, ...bankData }
          : item
      ));
    }
  };

  // Column definitions
  const columns = [
    {
      key: 'actions',
      label: 'Actions',
      render: (row) => (
        <div className="d-flex gap-1 justify-content-center">
          <Button 
            size="sm" 
            className="btn-outline-primary-custom"
            title="Edit"
            style={{
              padding: '0.25rem 0.5rem'
            }}
            onClick={() => handleEditBank(row)}
          >
            <i className="bi bi-pencil"></i>
          </Button>
        </div>
      )
    },
    { key: 'bankName', label: 'Bank Name' },
    { key: 'keyword', label: 'Keyword' },
    { key: 'ifsc', label: 'ifsc' },
    { key: 'maxlength', label: 'maxlength' },
    { key: 'minlength', label: 'minlength' },
    { key: 'verifyStatus', label: 'Verify Status' },
    { key: 'mode', label: 'mode' },
    { key: 'creditCard', label: 'Credit Card' }
  ];

  return (
    <Container fluid className="p-4">
      <SettingsTable
        data={data}
        settingsType="Bank Master"
        columns={columns}
        onAdd={handleAddBank}
      />
      <BankMasterModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        mode={modalMode}
        bankData={selectedBank}
        onSave={handleSaveBank}
      />
    </Container>
  );
};

export default BankMaster;

